import getConfig from 'next/config';
import { useMemo } from 'react';

export default function useNextConfig() {
  return useMemo(() => {
    const config = getConfig();
    return config?.publicRuntimeConfig ?? {};
  }, []);
}
